module.exports = "/* Welcome to Compass. Use this file to define print styles.\r\n * Import this file using the following HTML or equivalent:\r\n * <link href=\"/stylesheets/print.css\" media=\"print\" rel=\"stylesheet\" type=\"text/css\" /> */\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/css/print.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/css/print.css
// module chunks = styles